import Hls from "hls.js";
import { gsap } from "gsap/all";
// import { Magnetic } from "../../src/js/parts/magnetic.js";

// export const initVideo = () => {
//   const videos = [...document.querySelectorAll(".js-background-video")];
//   if (videos.length <= 0) {
//     return false;
//   }

//   videos.forEach((video) => {
//     new Video(video);
//   });
// };

export class BackgroundVideo {
  constructor(video) {
    this.video = video;
    console.log(this.video);
    this.src = this.video.getAttribute("data-src");
    this.parent = video.parentElement;
    this.img = document.querySelector(`.js-img-reveal`);
    this.init();
  }

  pause() {
    this.video.pause();
  }

  play() {
    gsap.to(this.img, 1, {
      opacity: 0,
      delay: 3,
    });
    this.video.play();
  }

  attach() {
    if (Hls.isSupported()) {
      this.hls = new Hls({
        maxMaxBufferLength: 4,
        startLevel: 2,
      });

      this.hls.attachMedia(this.video);
      this.hls.loadSource(this.src);

      this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
        this.isLoaded = true;

        this.play();
      });
    } else if (this.video.canPlayType("application/vnd.apple.mpegurl")) {
      this.video.src = this.src;

      this.video.addEventListener("loadedmetadata", () => {
        this.isLoaded = true;
        this.play();
      });
    }
  }

  init() {
    this.attach();
  }
}

export class Video {
  constructor(video) {
    this.video = video;
    console.log(this.video);
    this.srcDesktop = `https://player.vimeo.com/external/540127155.m3u8?s=b647cc1482063394f27b1599fe3de8f4e20a43ab`;
    this.srcMobile = `https://player.vimeo.com/external/540126973.m3u8?s=837da41716301d5b1ed90eff94293c73936558e8`;
    this.parent = video.parentElement;
    this.width = window.innerWidth;

    this.init();
  }

  pause() {
    this.video.pause();
  }

  play() {
    this.video.play();
  }

  attach() {
    if (Hls.isSupported()) {
      this.hls = new Hls({
        maxMaxBufferLength: 4,
        startLevel: 3,
      });

      this.hls.attachMedia(this.video);

      if (this.width > 800) {
        this.hls.loadSource(this.srcDesktop);
      } else {
        this.hls.loadSource(this.srcMobile);
      }

      this.hls.on(Hls.Events.MANIFEST_PARSED, () => {
        this.isLoaded = true;
      });
    } else if (this.video.canPlayType("application/vnd.apple.mpegurl")) {
      if (this.width > 800) {
        this.video.src = this.srcDesktop;
      } else {
        this.video.src = this.srcMobile;
      }

      this.video.addEventListener("loadedmetadata", () => {
        this.isLoaded = true;
      });
    }
  }

  init() {
    this.attach();
  }
}
